<template>
  <div class="classlist">
    <div class="list-top-box">
      <div class="list-top">
        <TopHead
          :top-type="'black'"
          :title="spver === 1 ? listHead[listTab] : '搜狗视频'"
        />
        <!-- 顶部横向大分类 -->
        <div class="list-nav">
          <div class="list-nav-box">
            <a
              v-for="(value, key) in listHead"
              :key="key"
              data-name="all"
              :uigs="'list_type_' + key"
              :class="listTab === key ? 'list-nav-item cur' : 'list-nav-item'"
              :href="`/list?listTab=${key}${spver ? '&spver=1' : ''}`"
              @click="classNavClick(value, key)"
            >{{ value }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 各种细分类 -->
    <template
      v-if="searchData && searchData.list && searchData.list.filter_list && searchData.list.filter_list.length > 0"
    >
      <ClassFilterNav
        :filter-data="filterList"
        :filter-class-nav="filterClassNav"
        :get-uigs="getClassFilterUigs"
      />
    </template>
    <!-- 检索出的结果 -->
    <template v-if="searchData && searchData.list && videoType.indexOf(searchData.list.entity) < 0">
      <ClassList
        v-if="classListData && classListData.length > 0"
        :data-list="classListData"
        :type="searchData.list.entity"
        :get-uigs="getUigs"
        :show-loading="!loadingFinished"
      />
    </template>
    <!-- ShortVideo -->
    <template v-if="searchData && searchData.list && videoType.indexOf(searchData.list.entity) >= 0">
      <ShortVideo
        :short-video="classListData"
        :get-uigs="getUigs"
        :show-loading="!loadingFinished"
      />
    </template>
    <!-- 筛选无结果 -->
    <template>
      <div
        v-if="!classListData || classListData.length === 0"
        class="class-list-noresult"
      >
        <div class="class-list-noresult-box">
          <p>抱歉，未能找到符合条件的影片</p>
          <span
            v-show="searchData && searchData.list"
            class="empty-btn"
            @click="filterClassNav(-1, -1, true)"
          >清空筛选</span>
        </div>
      </div>
    </template>
    <Gotop />
    <div
      v-if="false"
      class="list-banner"
    />
  </div>
</template>

<script>
import * as types from '@types';
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import TopHead from '../common/components/TopHead.vue';
import { getScrollParams } from '../common/js/util';
import pageExpose from '../common/mixins/pageExpose';
// 各种类型选择
import ClassFilterNav from './components/ClassFilterNav.vue';
// 具体展示的影视内容
import ClassList from './components/ClassList.vue';
import ShortVideo from './components/ShortVideo.vue';
const PAGE_SIZE = 15;

export default {
  components: {
    ClassList,
    ShortVideo,
    Gotop,
    TopHead,
    ClassFilterNav,
  },
  mixins: [pageExpose],
  data() {
    return {
      listHead: {
        teleplay: '电视剧',
        film: '电影',
        tvshow: '综艺',
        cartoon: '动漫',
        documentary: '纪录片',
      },
      videoType: ['mv', 'singleshow', 'essay', 'crosstalk', 'pair'],
      loading: false,
    };
  },
  computed: {
    ...mapState('common', ['loadingFinished']),
    ...mapState('list', ['searchData']),
    fr() {
      return this.$route.query.fr;
    },
    listTab() {
      let { listTab } = this.$route.query;
      const defaultTab = ['teleplay', 'tvshow', 'cartoon', 'film', 'documentary'];
      if (!listTab || defaultTab.indexOf(listTab) < 0) {
        listTab = 'teleplay';
      }
      return listTab;
    },
    classListData() {
      if (this.searchData && this.searchData.results) {
        return this.searchData.results || [];
      }
      return [];
    },
    spver() {
      return +this.$route.query.spver === 1 ? 1 : 0;
    },
    filterList() {
      const { list = {} } = this.searchData || {};
      return list.filter_list || [];
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('list/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_CLASSLIST_ERROR]', err));
  },
  mounted() {
    const self = this;
    self.searchData.list.filter_list = self.searchData.list.filter_list.filter(item => item.option_name !== 'starring');
    window.addEventListener('scroll', self.debounce());

    const [firstTab] = document.querySelectorAll('.list-nav .cur') || [];
    firstTab && firstTab.scrollIntoView({ block: 'center', inline: 'center' });

    document.body.addEventListener('click', (e) => {
      let ele = e.target;
      while (ele && ele.tagName !== 'A' && ele.tagName !== 'BODY') {
        ele = ele.parentNode;
      }
      if (ele && ele.tagName === 'A' && ele.className === 'class-item') {
        self.setSession();
      }
    });
    window.onpageshow = function () {
      let listData = JSON.parse(sessionStorage.getItem('listData')) || null;
      const listLoc = JSON.parse(sessionStorage.getItem('listLoc'));
      if (!listData || !listLoc) {
        return;
      }
      const preUrl = listLoc.url;
      const curUrl = window.location.href;
      if (performance && performance.navigation && performance.navigation.type !== 2) {
        return;
      }
      if (preUrl !== curUrl) {
        // 兼容performance.navigation.type
        sessionStorage.removeItem('listLoc');
        sessionStorage.removeItem('listData');
        return;
      }
      listData = JSON.parse(listData);
      if (listData) {
        self[types.UPDATE_LIST_RESULT](listData);
        self.start = listLoc.listLen;
        const scrollTop = parseInt(listLoc.scrolltop, 10);
        window.scrollTo(0, scrollTop);
        sessionStorage.removeItem('listLoc');
        sessionStorage.removeItem('listData');
      }
    };
  },
  methods: {
    ...mapMutations('common', [types.UPDATE_LOADING_FINISHED]),
    ...mapMutations('list', [types.UPDATE_LIST_RESULT]),
    /**
     * 滚动加载数据
     */
    getClassListData() {
      const self = this;
      const { searchData } = self;
      const winH = window.innerHeight;
      const listFooter = document.querySelector('.video-result');
      const top = listFooter && listFooter.getBoundingClientRect().top;
      if (self.loading || self.loadingFinished || top > winH || !searchData) return false;

      let params = searchData.$params;
      const { fr = 'filter', style = '', zone = '', year = '', fee = '', order = '', emcee = '' } = this.$route.query;
      const start = searchData.results.length;
      params.start = start;
      params = Object.assign(params, { fr, style, zone, year, fee, order, emcee });

      self.loading = true;
      // 发送请求
      axios({
        url: '/napi/video/classlist',
        params,
      })
        .then((result) => {
          const { data } = result;
          if (data && data.status === 0) {
            const { listData } = data;
            searchData.results = searchData.results.concat(listData.results);
            if (
              (Array.isArray(listData.results) && listData.results.length < PAGE_SIZE)
              || searchData.results.length >= searchData.totalitems
            ) {
              self[types.UPDATE_LOADING_FINISHED](true);
            }
            this[types.UPDATE_LIST_RESULT](searchData);
          }
          self.$nextTick(() => {
            self.loading = false;
          });
          // 滚动pblet
          const opts = getScrollParams({
            scrollParams: { addition: 'video', pn: Math.ceil(start / PAGE_SIZE) },
          });
          this.$uigs.send(opts);
        })
        .catch(() => {
          self.loading = false;
        });
    },
    classNavClick(value, key) {
      const { query } = this.$router.history.current;
      ['filter', 'class', 'style', 'zone', 'year', 'fee', 'zone', 'emcee', 'order'].forEach((item) => {
        delete query[item];
      });
      const { path } = this.$router.history.current;
      query.listTab = key;
      const qArr = [];

      Object.keys(query).forEach((key) => {
        if (query[key]) {
          qArr.push(`${key}=${encodeURIComponent(query[key])}`);
        }
      });

      const url = `${path}?${qArr.join('&')}`;
      location.href = url;
    },
    getClassFilterUigs(name, item, index, optionName) {
      return `list_filter_${optionName}_${index}_${item}`;
    },
    filterClassNav(index, filterIndex, clear, isNav = false) {
      const self = this;
      const { query, path } = this.$router.history.current;
      const qArr = [];
      self[types.UPDATE_LOADING_FINISHED](false);
      const { searchData } = this;
      if (!clear && filterIndex > -1) {
        searchData.list.filter_list[filterIndex].selected = index;
        this.$set(searchData.list.filter_list, filterIndex, searchData.list.filter_list[filterIndex]);
      } else if (clear) {
        for (let i = 0; i < searchData.list.filter_list.length; i += 1) {
          searchData.list.filter_list[i].selected = -1;
        }
        delete query.fr;
      }
      searchData.list = Object.assign({}, searchData.list);
      let queryStr = '';

      for (let i = 0; i < searchData.list.filter_list.length; i += 1) {
        const item = searchData.list.filter_list[i];
        const selected = parseInt(item.selected, 10);
        if (item.option_name === 'order') {
          if (selected === 0) {
            queryStr = `${queryStr + item.option_name}=time&`;
            query[item.option_name] = 'time';
          } else if (selected === 1) {
            queryStr = `${queryStr + item.option_name}=score&`;
            query[item.option_name] = 'score';
          }
        } else if (selected !== -1) {
          queryStr = `${queryStr + item.option_name}=${item.option_list[selected]}&`;
          query[item.option_name] = item.option_list[selected];
        }
        if (selected === -1) {
          if (query[item.option_name]) {
            delete query[item.option_name];
          }
        }
      }

      delete query.class;
      query.class = 1;
      let filterArr = [];

      if (query.filter) {
        if (query.filter.indexOf('+') > -1) {
          filterArr = query.filter.split('+');
        } else {
          filterArr = query.filter.split(' ');
        }
        delete query.filter;
      }

      for (let i = 0; i < filterArr.length; i += 1) {
        if (filterArr[i].indexOf('-') > -1) {
          const key = filterArr[i].split('-')[0];
          const v = filterArr[i].split('-')[1];
          if (!query[key]) {
            query[key] = v;
          }
        }
      }

      Object.keys(query).forEach((key) => {
        if (query[key]) {
          qArr.push(`${key}=${query[key]}`);
        }
      });

      queryStr += `entity=${searchData.list.entity}&class=1&fr=filter&len=${PAGE_SIZE}`;
      let url = `${path}?${qArr.join('&')}`;
      const localPath = decodeURI(location.pathname + location.search);

      if (localPath === url) {
        return;
      }
      if (!isNav) {
        if (!query.fr || query.fr !== 'filter') {
          url += '&fr=filter';
        }
        history.pushState(null, null, url);
      }

      const spverUrl = +this.spver === 1 ? '&spver=1' : '';
      axios(`/napi/video/re?${queryStr}&req=list${spverUrl}`)
        .then((res) => {
          searchData.results = res.data.data.results;
          if (searchData.results.length < PAGE_SIZE) {
            self[types.UPDATE_LOADING_FINISHED](true);
          }
          this[types.UPDATE_LIST_RESULT](searchData);
        })
        .catch(() => {
          self[types.UPDATE_LOADING_FINISHED](true);
        });
    },
    getUigs({ index, item }) {
      let type = item.dockey.split('_')[0];
      if (type === 'film') {
        type = 'movie';
      }
      return `list_item_${type}_${index}_${item.name}`;
    },
    setSession() {
      const url = window.location.href;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const datalen = this.searchData.results.length;
      const { listType } = this;
      const loc = { scrolltop: scrollTop, listLen: datalen, listType, url };
      const listData = JSON.stringify(this.searchData);
      sessionStorage.setItem('listLoc', JSON.stringify(loc));
      sessionStorage.setItem('listData', JSON.stringify(listData));
    },
    debounce() {
      // 防抖or节流函数
      let timer = null;
      const self = this;
      return function () {
        if (!timer) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            self.getClassListData();
            timer = null;
          }, 500);
        }
      };
    },
  },
};
</script>

<style lang="scss">
a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  outline: none;
  background: none;
  text-decoration: none;
}
a {
  color: #222;
}
.list-top-box {
  height: 106px;
}
.list-top {
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
}

.list-nav {
  position: relative;
  height: 48px;
  padding: 0 15px 0 10px;
  border-bottom: 1px rgba(241, 241, 241, 1) solid;
  overflow: hidden;
  .list-nav-box {
    display: flex;
    flex-wrap: nowrap;
    overflow: scroll;
    white-space: nowrap;
    height: 80px;
    -webkit-overflow-scrolling: touch;
    justify-content: space-around;
    .list-nav-item {
      color: rgba(85, 85, 85, 1);
      line-height: 49px;
      font-size: 17px;
      position: relative;
    }
    .list-nav-item.cur:after {
      content: '';
      position: absolute;
      width: 70%;
      height: 2px;
      border-radius: 1px;
      background-color: #000;
      top: 46px;
      left: 15%;
    }
    .cur {
      font-size: 17px;
      font-weight: bold;
      color: rgba(34, 34, 34, 1);
    }
  }
}
.list-banner {
  height: 8px;
  background: #f2f2f2;
}
.class-list-noresult {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-bottom: 8px solid #f2f2f2;
  .class-list-noresult-box {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    p {
      font-size: 14px;
      color: rgba(85, 85, 85, 1);
    }
    .empty-btn {
      display: block;
      width: 100px;
      height: 35px;
      border-radius: 3px;
      border: 1px solid rgba(34, 34, 34, 0.5);
      font-size: 14px;
      color: rgba(34, 34, 34, 1);
      line-height: 35px;
      text-align: center;
      margin-top: 15px;
    }
  }
}
</style>
